import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import type { EntityRecord } from '#shared/cms/records'

type EntityValue = Omit<EntityRecord, '$type'>

interface EntityEntry {
  rkey: string
  uri: string
  cid: string
  value: EntityRecord
}


export default /*@__PURE__*/_defineComponent({
  __name: '[rkey]',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'Edit entity - admin - Daniel Roe' })

const route = useRoute()
const rkey = computed(() => {
  const raw = route.params.rkey
  return typeof raw === 'string' && raw ? raw : null
})

if (!rkey.value) {
  throw createError({ statusCode: 404, statusMessage: 'Missing rkey.' })
}

const { data, loading } = useAdminFetch<EntityEntry>(`/api/admin/entities/${rkey.value}`, {
  watch: false,
})

async function save (value: EntityValue) {
  if (!rkey.value) return
  await $fetch(`/api/admin/entities/${rkey.value}`, { method: 'PUT', body: value })
  await navigateTo('/admin/entities')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminEntityForm = _resolveComponent("AdminEntityForm")!
  const _component_AdminSkeletonForm = _resolveComponent("AdminSkeletonForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "Edit entity" }, {
    default: _withCtx(() => [
      (_unref(data))
        ? (_openBlock(), _createBlock(_component_AdminEntityForm, {
            key: 0,
            initial: _unref(data).value,
            "submit-label": "Save",
            onSubmit: save
          }, null, 8, ["initial"]))
        : (_unref(loading))
          ? (_openBlock(), _createBlock(_component_AdminSkeletonForm, {
              key: 1,
              fields: ['text', 'text', 'text', 'text', 'text']
            }))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})